<template>
  <Modal
    title="Exportar extrato"
    data-testid="export-modal"
    size="md"
    :is-open="isOpen"
    @close="close"
  >
    <div class="export-modal">
      <div class="export-modal__movement">
        <Heading class="export-modal__movement-title" :level="3">
          Movimentações
        </Heading>
        <FilterList
          v-model="filtersValue.movementType"
          data-testid="movement-type"
          :options="typesOptions"
        />
      </div>
      <div class="modal-content__period">
        <Heading class="export-modal__period-title" :level="3">Período</Heading>
        <FilterList
          v-model="filtersValue.datePeriod"
          data-testid="period"
          class="modal-content__period-list"
          :options="periodsOptions"
        />
      </div>
    </div>
    <template #buttons>
      <div class="buttons">
        <ButtonSecondary label="Cancelar" @click="close" />
        <ButtonPrimary
          :loading="isLoading"
          class="buttons__export"
          label="Exportar"
          @click="submit"
        />
      </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {
  Modal,
  Heading,
  FilterList,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';
import { IFilters } from '@/modules/transaction/views/Transactions/components/StatementList/types';
import { parseFilterOptions } from '../../helpers';

@Component({
  components: {
    Modal,
    Heading,
    FilterList,
    ButtonPrimary,
    ButtonSecondary
  }
})
export default class ExportModal extends Vue {
  @Prop({ type: Object, required: true })
  readonly filters!: IFilters;

  @Prop({ type: Boolean, default: false })
  readonly isOpen!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly isLoading!: boolean;

  @Emit('submit')
  submit() {
    return this.filtersValue;
  }

  @Emit('close')
  close() {}

  public filtersValue = {
    datePeriod: 'SEVEN_DAYS',
    movementType: 'ALL'
  };

  get typesOptions() {
    return parseFilterOptions(this.filters.types);
  }

  get periodsOptions() {
    const periodOptions = parseFilterOptions(this.filters.datePeriods);
    const periodOptionsParsed = periodOptions.filter(
      option => option.label !== 'Tudo'
    );
    return periodOptionsParsed;
  }
}
</script>

<style lang="less" scoped>
.export-modal {
  &__movement {
    margin-bottom: @size-spacing-x500;
  }
  &__movement-title {
    text-align: left;
    margin-bottom: @size-spacing-x500;
  }
  &__period-title {
    text-align: left;
    margin-bottom: @size-spacing-x500;
    margin-top: @size-spacing-x700;
  }
}
.buttons {
  padding: @size-spacing-x450 0;
  &__export {
    margin-left: @size-spacing-x300;
  }
}
</style>
